import { CrmContactImportFeaturePage } from "..";

/** 联系人批量导入路由页面。 */
export function CrmContactImportPage() {
  return <CrmContactImportFeaturePage />;
}
